import { NoImagePlaceholder } from './no-image-placeholder';
import { useBrokenImage } from './use-broken-image';
import type { CardImageProps } from './card-image.types';

import css from './card-image.module.css';

/**
 * Web card image: a plain <img>, not expo-image.
 *
 * Same reasoning as the hero in hero-search.web.tsx — expo-image only inserts
 * its <img> after hydration, so nothing is discoverable by the preload scanner
 * and nothing can be lazied. On the /events and /tours hubs that meant ~20
 * card images (1.2MB on tours) all fetching eagerly once the bundle ran. A raw
 * <img> ships in the static HTML, so `loading="lazy"` actually applies.
 */
export function CardImage({ uri, alt, eager = false }: CardImageProps) {
  const { broken, ref, onError } = useBrokenImage();
  if (!uri || broken) {
    return <NoImagePlaceholder />;
  }
  return (
    <img
      ref={ref}
      src={uri}
      alt={alt}
      className={css.img}
      loading={eager ? 'eager' : 'lazy'}
      fetchPriority={eager ? 'high' : 'auto'}
      decoding="async"
      onError={onError}
    />
  );
}
